import { format, unwrapFunctionStore } from 'svelte-i18n';

import { studioSettingsStore } from '@client/stores/page-settings';

import { GLOBAL_DRIVER_OBJECT, GLOBAL_LOADER_STEP } from '@client/enums';

import { cloneViaSigCard } from '../clone/clone-sig-card';
import { cloneViaSigEditor } from '../clone/clone-sig-editor';
import { cloneToDomain } from '../clone/clone-to-domain';
import { cloningSignature } from '../clone/cloning-sig';
import { cloningOptions } from '../clone/options';
import { sigEditorActions } from '../clone/sig-editor-actions';
import { clickNewSignature } from '../create/click-new-sig';
import { creatingSignature } from '../create/creating-sig';
import { blankSignature, optionChoice, osDesginSignature, templateSignature } from '../create/options';
import { carouselNavigation, clickUseTemplate, usingTemplate } from '../create/using-template';
import { accessingSigEditor } from '../edit/accessing-sig-editor';
import { editingSignature } from '../edit/editing-sig';
import { addingField, hidingField, managingFields, removingField, reorderingField } from '../edit/fields';
import { changingHtmlCss } from '../edit/html-css';
import { menuOptions } from '../edit/options';
import { previewingChanges, previewSettings } from '../edit/preview';
import { darkMode, proTip, unparsedPreview } from '../edit/pro-tip';
import { savingSignature } from '../edit/save';
import { sigEditorA, sigEditorB } from '../edit/sig-editor';
import { updatingSignature } from '../edit/updating-sig';
import { cardWarnings, signatureCard } from '../overview/card';
import { archivedFilter, searchFilter, sortingFilter } from '../overview/filters';
import { studioOverview } from '../overview/overview';

const $format = unwrapFunctionStore(format);

let fullSteps = [
  studioOverview,
  searchFilter,
  archivedFilter,
  sortingFilter,
  signatureCard,
  cardWarnings,
  creatingSignature,
  clickNewSignature,
  optionChoice,
  blankSignature,
  osDesginSignature,
  templateSignature,
  usingTemplate,
  carouselNavigation,
  clickUseTemplate,
  cloningSignature,
  cloneViaSigCard,
  cloningOptions,
  cloneToDomain,
  cloneViaSigEditor,
  sigEditorActions,
  GLOBAL_LOADER_STEP,
  editingSignature,
  accessingSigEditor,
  menuOptions,
  GLOBAL_LOADER_STEP,
  updatingSignature,
  changingHtmlCss,
  sigEditorA,
  sigEditorB,
  proTip,
  unparsedPreview,
  darkMode,
  managingFields,
  addingField,
  removingField,
  hidingField,
  reorderingField,
  previewingChanges,
  previewSettings,
  savingSignature
];

let escapeListener = null;

fullSteps[5] = {
  ...fullSteps[5],
  popover: {
    ...fullSteps[5].popover,
    nextBtnText: "Next <i class='os-icon-arrow-right'></i> Create Tour",
    onNextClick: () => {
      studioSettingsStore.update((studio) => {
        return {
          ...studio,
          tours: {
            ...studio.tours,
            overviewHasToured: true
          }
        };
      });

      GLOBAL_DRIVER_OBJECT.moveNext();
    }
  }
};

fullSteps[14] = {
  ...fullSteps[14],
  popover: {
    ...fullSteps[14].popover,
    nextBtnText: $format('label.TOURS.STUDIO.CREATE.NEXT_BTN_TEXT'),
    onNextClick: () => {
      const closeButton = document.querySelector('.close');

      if (escapeListener) {
        document.removeEventListener('keydown', escapeListener);
      }

      studioSettingsStore.subscribe((studio) => {
        studio.tours.createHasToured = true;
      })();

      if (closeButton) {
        closeButton.click();

        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};

fullSteps[15] = {
  ...fullSteps[15],
  popover: {
    ...fullSteps[15].popover,
    showButtons: ['next']
  }
};

fullSteps[20] = {
  ...fullSteps[20],
  popover: {
    ...fullSteps[20].popover,
    onPopoverRender: () => {
      const sigActions = document.querySelector('div.page-header .btn-group > button');

      if (sigActions) {
        sigActions.click();

        GLOBAL_DRIVER_OBJECT.highlight({
          element: 'div.hide--mobile.btn-group > ul.dropdown-menu',
          popover: {
            title: $format('label.TOURS.STUDIO.CLONE.SIG_EDITOR_ACTIONS.TITLE'),
            description: $format('label.TOURS.STUDIO.CLONE.SIG_EDITOR_ACTIONS.DESCRIPTION'),
            side: 'left',
            align: 'start',
            showButtons: ['next'],
            nextBtnText: $format('label.TOURS.STUDIO.CLONE.NEXT_BTN_TEXT'),

            onNextClick: () => {
              const studioButton = document.querySelector(
                '#signature-editor > div.page-header > div > div:nth-child(1) > div > nav > ol > li:nth-child(2) > a'
              );

              studioSettingsStore.subscribe((studio) => {
                studio.tours.cloneHasToured = true;
              })();

              if (studioButton) {
                studioButton.click();

                GLOBAL_DRIVER_OBJECT.moveNext();
              }
            }
          }
        });
      }
    }
  }
};

fullSteps[21] = {
  ...fullSteps[21],
  popover: {
    ...fullSteps[21].popover,
    title: 'Loading manager...'
  }
};

fullSteps[25] = {
  ...fullSteps[25],
  popover: {
    ...fullSteps[25].popover,
    title: 'Loading signature...'
  }
};

fullSteps[40] = {
  ...fullSteps[40],
  popover: {
    ...fullSteps[40].popover,
    onNextClick: () => {
      const studioButton = document.querySelector(
        '#signature-editor > div.page-header > div > div:nth-child(1) > div > nav > ol > li:nth-child(2) > a'
      );

      studioSettingsStore.subscribe((studio) => {
        studio.tours = {
          ...studio.tours,
          hasToured: true,
          editHasToured: true
        };
      })();

      if (studioButton) {
        studioButton.click();

        GLOBAL_DRIVER_OBJECT.destroy();
      }
    }
  }
};

export const FULL_STEPS = fullSteps;
